import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');

const propTypes = {
    inputId: PropTypes.string,
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityLocked: PropTypes.bool.isRequired,
    channelUserPermissions: PropTypes.object,
    projectUserPermissions: PropTypes.object
};

const defaultProps = {
    inputId: 'act-description',
    className: '',
    channelUserPermissions: {},
    projectUserPermissions: {}
};

class ActivityDescriptionEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activityStoreState: ActivityStore.getStateActivity(props.activityId, props.projectId, props.channelId),
            description: '',
            descriptionClean: true,
            descriptionUpdateActionId: null
        };

        this.setDescription = this.setDescription.bind(this);
        this.updateDescription = this.updateDescription.bind(this);

        this.unsubscribes = [ActivityStore.listen(this.onActivityStoreStateChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onActivityStoreStateChange(newState) {
        let updatedState = { activityStoreState: ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId) };

        if (newState.action.id === this.state.descriptionUpdateActionId) {
            updatedState = { ...updatedState, descriptionClean: true, descriptionUpdateActionId: null };
        }

        this.setState(updatedState);
    }

    setDescription(e) {
        this.setState({ description: e.target.value, descriptionClean: false });
    }

    updateDescription() {
        const actionId = uuid.v4();
        this.setState({ descriptionUpdateActionId: actionId }, () => {
            ActivityActions.setDescriptionActivity(actionId, {
                activityID: this.props.activityId,
                projectID: this.props.projectId,
                description: this.state.description.toString()
            });
        });
    }

    render() {
        if (!this.state.activityStoreState.activity) {
            return null;
        }

        const storeActivity = this.state.activityStoreState.activity;
        if (!storeActivity) {
            return null;
        }

        const actDescription = this.state.descriptionClean ? storeActivity.meta_data.description : this.state.description;
        const canEditActivity = PermissionsUtil.canEditActivity(this.props.channelUserPermissions, this.props.projectUserPermissions);

        return (
            <div className={this.props.className}>
                <textarea
                    id={this.props.inputId}
                    className="actEditMetaDataInput margin-bottom-md"
                    value={actDescription}
                    placeholder={Strings['en'].activity.description.TA_PLACEHOLDER}
                    rows='4'
                    disabled={this.state.activityLocked || !canEditActivity}
                    onChange={this.setDescription}
                />
                { canEditActivity &&
                    <button
                        className="btn btn-primary block"
                        onClick={this.updateDescription}
                        disabled={this.state.descriptionClean || !!this.state.descriptionUpdateActionId || this.props.activityLocked}
                    >
                        {Strings['en'].common.UPDATE}
                    </button>
                }
            </div>
        );
    }
}

ActivityDescriptionEditor.propTypes = propTypes;
ActivityDescriptionEditor.defaultProps = defaultProps;

export default ActivityDescriptionEditor;